import styled from 'styled-components';

export const FooterContainer = styled.div`
  background: #083a81;
  border-bottom: 13px solid #041d40;
  color: #666;
  font-family: 'Gotham-Book', arial, sans-serif;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0.02em;
  @media (max-width: 760px) {
    font-size: 15px;
    line-height: 22px;
  }
  @media print {
    display: none;
  }
`;

export const Footer = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 35px 0;
  font-family: 'Gotham-Medium', arial, sans-serif;
  font-size: 18px;
  line-height: 24px;
  color: #2db13a;

  @media (max-width: 1199px) {
    width: 960px !important;
  }
  @media (max-width: 991px) {
    width: 728px !important;
  }
  @media (max-width: 767px) {
    width: 100% !important;
    margin: 0;
    padding: 35px 25px 15px 25px;
    text-align: center;
  }
`;

export const FooterLeft = styled.div`
  text-align: left;
  float: left;
  width: 50%;

  @media (max-width: 767px) {
    float: none;
    width: 100%;
    margin: 0 0 25px 0;
  }
`;

export const ImageStyle = styled.img`
  width: 462px;
  height: auto;
  border: 0;
  vertical-align: top;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

export const AnchorStyle = styled.a`
  font-family: 'Gotham-Medium', arial, sans-serif;
  font-size: 13px;
  line-height: 13px;
  text-transform: uppercase;
  color: #0397d6;
  text-decoration: none;
  margin: 0 15px;

  :hover {
    color: #1fb25a;
    text-decoration: none;
  }
`;

export const FootRight = styled.div`
  float: right;
  text-align: right;
  width: 50%;
  padding: 23px 25px 0 0;
  @media (max-width: 991px) {
    padding-top: 10px;
  }
  @media (max-width: 767px) {
    float: none;
    width: 100%;
    text-align: center;
  }
`;
